require('./lbaFileUploader.scss');

const $inject = [];
const lbaFileUploader = function () {
  return {
    restrict: 'A',
    scope: {
      settings: '<',
    },
    bindToController: true,
    controller: 'lbaFileUploaderCtrl',
    controllerAs: 'vm',
    template: require('./lbaFileUploader.html')
  }
};

lbaFileUploader.$inject = $inject;

export default lbaFileUploader;



// WEBPACK FOOTER //
// ./src/components/lbaFileUploader/lbaFileUploaderDir.js